import React, { useState } from 'react';
import { FaLinkedin } from 'react-icons/fa';
import { CiMail } from "react-icons/ci";
import { IoLocationOutline } from "react-icons/io5";
import me from '../images/me.jpg';

const Contact: React.FC = () => {
    const [formState, setFormState] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [formErrors, setFormErrors] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [formSuccess, setFormSuccess] = useState('');

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormState({ ...formState, [name]: value });
    };

    const validateForm = () => {
        let errors = { name: '', email: '', subject: '', message: '' };
        let isValid = true;

        if (formState.name.length < 4) {
            errors.name = 'Please enter your name';
            isValid = false;
        }
        if (!/\S+@\S+\.\S+/.test(formState.email)) {
            errors.email = 'Please enter a valid email';
            isValid = false;
        }
        if (formState.subject.length < 1) {
            errors.subject = 'Please enter a subject';
            isValid = false;
        }
        if (formState.message.length === 0) {
            errors.message = 'Please write something for me :)';
            isValid = false;
        }

        setFormErrors(errors);
        return isValid;
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                const response = await fetch('https://formspree.io/f/mwpkqoaa', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formState)
                });
                if (response.ok) {
                    setFormSuccess('Your message has been sent. Thank you!');
                    setFormState({ name: '', email: '', subject: '', message: '' });
                    setFormErrors({ name: '', email: '', subject: '', message: '' });
                } else {
                    setFormSuccess('There was an error sending your message. Please try again.');
                }
            } catch (error) {
                setFormSuccess('There was an error sending your message. Please try again.');
            }
        }
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-sm-12">
                    <div className="title-box text-center">
                        <h1 className="title-a">Contact</h1>
                        <div className="line-mf"></div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <div className="row">
                        <div className="col-md-6 contact-box">
                            <div className='social-icons img-container'>
                                <img src={me} alt="Me" className="me-image" /> {/* Add your picture here */}
                            </div>
                            <div className='social-icons'>
                                <IoLocationOutline className="location" /> Windsor, UK
                            </div>

                            <div className="title-box-2 pt-4 pt-md-0">
                                <h5 className="title-left">Get in Touch</h5>
                            </div>
                            <div className="more-info">
                                <p className="lead">
                                    Have a project in mind or just want to say hello? I'd love to hear from you.
                                    Fill out the form to drop me an email.
                                </p>

                            </div>
                            <div className="social-icons">
                                <a href="https://www.linkedin.com/in/sudefidan" target="_blank" rel="noopener noreferrer" className="social-icon">
                                    <FaLinkedin />
                                </a>
                                <a href="mailto:sudeff382@gmail.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                                    <CiMail />
                                </a>
                            </div>
                        </div>
                        <div className="col-md-6 contact-box">
                            <div>
                                <form onSubmit={handleSubmit}>
                                    {formSuccess && <div id="sendmessage">{formSuccess}</div>}
                                    <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control"
                                                    id="name"
                                                    placeholder="Your Name"
                                                    value={formState.name}
                                                    onChange={handleInputChange}
                                                />
                                                {formErrors.name && <div className="validation">{formErrors.name}</div>}
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <div className="form-group">
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    name="email"
                                                    id="email"
                                                    placeholder="Your Email"
                                                    value={formState.email}
                                                    onChange={handleInputChange}
                                                />
                                                {formErrors.email && <div className="validation">{formErrors.email}</div>}
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="subject"
                                                    id="subject"
                                                    placeholder="Subject"
                                                    value={formState.subject}
                                                    onChange={handleInputChange}
                                                />
                                                {formErrors.subject && <div className="validation">{formErrors.subject}</div>}
                                            </div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <div className="form-group">
                                                <textarea
                                                    className="form-control"
                                                    name="message"
                                                    rows={5}
                                                    placeholder="Message"
                                                    value={formState.message}
                                                    onChange={handleInputChange}
                                                ></textarea>
                                                {formErrors.message && <div className="validation">{formErrors.message}</div>}
                                            </div>
                                        </div>
                                        <div className="col-md-12 text-center">
                                            <button
                                                type="submit"
                                                className="button button-a button-big button-rouded"
                                            >
                                                Send Message
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;